module.exports = __webpack_public_path__ + "img/8.986f442d.jpg";